import React from "react";
import { BarClient } from "../BarClient";
import { AllSoftCompany } from "../../soft/AllSoftCompany";
import { CompanyAnalyticsPanel } from "../analytics/CompanyAnalyticsPanel";
import { CompanyClientLkEmployeesPanel } from "./CompanyClientLkEmployeesPanel";
import {
  CompanyInvoices1cPanel,
  TAB_NAME_1C,
} from "./CompanyInvoices1cPanel";

const isNavActive = (nav, name) =>
  nav.find((item) => item.name === name)?.active ?? false;

export function CompanyCardSoftSection({
  nav,
  clickNav,
  companyId,
  versionFilterOn,
  setVersionFilterOn,
  setIdSearch,
  idSearch,
  refSoftCompany,
  showNoProductionFilter = true,
}) {
  const softActive = isNavActive(nav, "soft");
  const invoices1cActive = isNavActive(nav, TAB_NAME_1C);
  const analiticActive = isNavActive(nav, "analitic");
  const incidentActive = isNavActive(nav, "incident");
  const employeesActive = isNavActive(nav, "employees");

  return (
    <div className="company-card-v4-soft-section">
      <nav
        className="navigation-tabs company_container_submenu_nav"
        aria-label="Разделы карточки компании"
      >
        {nav
          .filter((f) => f.allowed)
          .map((btn) => (
            <span
              key={btn.name}
              className={btn.active ? "tab-item active" : "tab-item"}
              onClick={() => clickNav(btn)}
            >
              {btn.nameRu}
            </span>
          ))}
      </nav>

      {softActive ? (
        <div className="filters-bar">
          <BarClient
            v4Layout
            versionFilterOn={versionFilterOn}
            setVersionFilterOn={setVersionFilterOn}
            setIdSearch={setIdSearch}
            showNoProductionFilter={showNoProductionFilter}
          />
        </div>
      ) : null}

      {softActive ? (
        <div
          ref={refSoftCompany}
          className="card table-container company-card-v4-soft-table"
        >
          <AllSoftCompany
            v4Layout
            setIdSearch={setIdSearch}
            idSearch={idSearch}
          />
        </div>
      ) : null}

      {invoices1cActive ? (
        <CompanyInvoices1cPanel companyId={companyId} />
      ) : null}

      {analiticActive ? (
        <CompanyAnalyticsPanel page="analitic" companyId={companyId} />
      ) : null}
      {incidentActive ? (
        <CompanyAnalyticsPanel page="incident" companyId={companyId} />
      ) : null}
      {employeesActive ? (
        <CompanyClientLkEmployeesPanel companyId={companyId} />
      ) : null}
    </div>
  );
}
